import { AfterViewInit, Component, inject } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { AuthService } from '../../../common/services/auth.service';

@Component({
  selector: 'app-logout',
  standalone: false,
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent extends BaseComponent implements AfterViewInit {

  #authService = inject(AuthService);
  #sessionExpired = this.router.getCurrentNavigation()?.extras?.state?.['reason'] === 'expired';

  ngAfterViewInit(): void {
    this.removeZenDesk();
    this.#authService.logout(this.#sessionExpired).subscribe({
      error: () => {

      }
    });
  }

  removeZenDesk(): void {
    const zenDeskNode = document.getElementById('ze-snippet');
    if (zenDeskNode && typeof (window as any).zE === 'function') {
      (window as any).zE('messenger', 'hide');
    }
  }
}
